export default {
      id: "important-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "sprite.svg#important",
      toString: function () {
        return this.url;
      }
    }